import toolbox from 'libwtgserver/toolbox';

function webrtc() {
'use strict';
 window.XPeerConnection = window.webkitRTCPeerConnection || window.mozRTCPeerConnection || window.RTCPeerConnection;
 window.XSessionDescription = window.RTCSessionDescription || window.mozRTCSessionDescription || window.RTCSessionDescription;
 window.XIceCandidate = window.RTCIceCandidate || window.mozRTCIceCandidate || window.RTCIceCandidate;
 navigator.getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia
                          || navigator.getUserMedia // TODO: are we serious about having it as a non-final callback?
                          || (navigator.mediaDevices && navigator.mediaDevices.getUserMedia);

 var _peer_connections = {};
 var _selfid,_local_stream;
 var _device_id,_conv_id;
 var WTGTB = new toolbox();
 var _socket=null;
 var _L;
 var _cb=null;
 var THAT=this;
 var _is_in_negotiation=true;
 var _peerConnectionConfig = {
  iceServers: [{'urls': 'stun:stun.l.google.com:19302'}].concat(
               (typeof WTGCONFIG !== 'undefined') && WTGCONFIG && WTGCONFIG.turn_servers || []),
  sdpSemantics:'unified-plan'
 };
 function get_peer_connection(id,s) {
  if (_peer_connections[id]) 
    return _peer_connections[id];
  var pc = new window.XPeerConnection(_peerConnectionConfig);
  if(s) s.getTracks().forEach(function(track){pc.addTrack(track, s)});
  pc.onicecandidate = function (evnt) {
   pc.oniceconnectionstatechange = function() {
    if (pc.iceConnectionState === "disconnected") _cb({type:'call-interrupted'});
   };
   if(evnt.candidate)
    _socket.sendMessage(
     WTGTB.number2Bytes(_conv_id),
     10,
     JSON.stringify({
      by:_selfid,
      to:id,
      ice:evnt.candidate,
      type:'video-ice'
     }),
     WTGTB.number2Bytes(_device_id),
     5000
    );
  };
  pc.onnegotiationneeded = function(/*evnt*/) {
   if(_is_in_negotiation) return;
   THAT.make_offer(pc.id,_local_stream);
  };
  pc.onsignalingstatechange=function() {
   var state=pc.signalingState || pc.readyState;
   if(state=='stable')
    _is_in_negotiation=false;
   };
  pc.ontrack = gotRemoteStream;
  _peer_connections[id] = pc;
  pc.id=id;
  return pc;
 }

 this.init = function(selfID,s,log,cb) {
  _selfid=selfID;
  _socket=s;
  _L=log;
  _cb=cb;
 };
 this.set_target=function(cid,did) {
  if(!(cid&&did)) return _L.info('WRTC target details missed!');
  _device_id=did;
  _conv_id=cid;
 };

 this.set_local_stream=function(s) {
  _local_stream=s;
 };
 this.switchStream=function(on,type,id) {
  var s=get_peer_connection(id).getLocalStreams();
  if(s.length && s[0]['get'+type+'Tracks']().length) s[0]['get'+type+'Tracks']()[0].enabled=on;
 };
 this.addTrack=(id,t)=>{
  var pc=get_peer_connection(id);
  if(pc) {
    _local_stream.addTrack(t);
    pc.addTrack(t,_local_stream);
  }
 };
 this.getSupportedMedia=function (){
  return navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia || navigator.mediaDevices.getUserMedia;
 };
 this.make_offer = function(id,stream) {
  if(!(_device_id&&_conv_id)) return _L.info('No target details specified!');
  _is_in_negotiation=true;
  var pc = get_peer_connection(id,stream);
  pc.createOffer().then(function (sdp) {
   pc.setLocalDescription(sdp).then(function () {
    var d={by:_selfid, to:id, sdp:sdp, type:'video-offer' };
    _socket.sendMessage(
     WTGTB.number2Bytes(_conv_id),
      10,//TODO:: This magic number tobe from a mapping
      JSON.stringify(d),WTGTB.number2Bytes(_device_id),
     5000
    );
   }).catch(function (e) {
    _L.info(e);
   });
  }).catch(function (e) {
   _L.info(e);
  });
 };
 this.closeVideo= function(id) {
  _is_in_negotiation=true;
  var pc = get_peer_connection(id);
  if(_local_stream){
    _local_stream.getAudioTracks().forEach(function(track) {
      track.stop();
    });

    _local_stream.getVideoTracks().forEach(function(track) {
      track.stop();
    });
  }
  pc.close();
  delete _peer_connections[id];
 };

 this.removeTrack = function(id,type){
  var pc=get_peer_connection(id);
  pc.getSenders().forEach(function(s){
   if(s.track&&s.track.kind==type){
    pc.removeTrack(s);
   }
  });
 };

 this.handleMessage=function(data) {
  switch (data.type) {
   case 'video-offer':
    if(!(_device_id&&_conv_id)) return _L.info('No target details specified!');
    var pc_offer = get_peer_connection(data.by, _local_stream);
     pc_offer.setRemoteDescription(data.sdp).then(function () {
      pc_offer.createAnswer().then(function (sdp) {
       pc_offer.setLocalDescription(sdp).then(function () {
        //set local desc done
        let d={by:_selfid, to:data.by, sdp:sdp, type:'video-answer'};
        _socket.sendMessage(
         WTGTB.number2Bytes(_conv_id),
         10,
         JSON.stringify(d),
         WTGTB.number2Bytes(_device_id),
         5000
        );
       }).catch(function (e) {
        _L.info(e);
       });
      }).catch(function(err){
       _L.info(err);
      });
    }).catch(function (e) {
     _L.error(e);
    });
    break;
   case 'video-answer':
   if(!(_device_id&&_conv_id)) return _L.info('No target details specified!');
   var pc_answer = get_peer_connection(data.by);
   pc_answer.setRemoteDescription(data.sdp).then(function () {
     _L.info('Setting remote description by answer');
    }).catch(function (e) {
     _L.error(e);
    });
    break;
   case 'video-ice':
    if(!(_device_id&&_conv_id)) return _L.info('No target details specified!');
    if (data.ice) {
     var pc_ice = get_peer_connection(data.by);
     pc_ice.addIceCandidate(data.ice);
    }
    break;
   case 'video-request':
   case 'video-response':
   case 'media-change':
   case 'video-close':
    _cb(data);
   break;
  }
 };
 function gotRemoteStream(event) {
  var atrack = event.streams[0].getAudioTracks();
  var vtrack = event.streams[0].getVideoTracks();
  var stream=new MediaStream();
  if(atrack.length) stream.addTrack(atrack[atrack.length-1]);
  if(vtrack.length) stream.addTrack(vtrack[vtrack.length-1]);
  _cb({type:'remote-stream',s:stream});
 }
}

export default webrtc;
/* vim:set sw=1 ts=8 expandtab: */
